<template>
  <div class="text-info">
    <h4 class="text-red">No data to display.</h4>
    <p>Please enter the search criteria and click the search button.</p>
    <p>
      <i class="fa fa-exclamation-triangle"></i>
      The broader the search criteria, the longer it takes to show results.
    </p>
  </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/NoDataMessage.vue